import { Writable, writable } from 'svelte/store';

type StoreSettings = {
	publicKey?: string | null;
	primaryColor?: string | null;
	secondaryColor?: string | null;
	darkMode?: boolean | null;
	eventUrl?: string | null;
	eventCode?: string | null;
	buttonText?: string | null;
	invitationCode?: string | null;
	ticketTypeCode?: string | null;
	autoValidationCode?: string | null;
	membershipCode?: string | null;
	borderRadius?: boolean | null;
};

export const storeSettings: Writable<StoreSettings> = writable();
